<template>
  <div class="home-image-management">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>首页轮播图</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="handleAdd">新增轮播图</el-button>
      </div>
      <el-table :data="images" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="100"></el-table-column>
        <el-table-column label="图片" width="180">
          <template slot-scope="scope">
            <div class="media-preview" v-if="scope.row.imagePath || scope.row.image_path">
              <img :src="scope.row.imagePath || scope.row.image_path" class="media-img" @click="previewImage(scope.row.imagePath || scope.row.image_path)">
            </div>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="imagePath" label="路径"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="!loading && images.length === 0" class="empty-state">
        <el-empty description="暂无轮播图">
          <el-button type="primary" @click="handleAdd">添加轮播图</el-button>
        </el-empty>
      </div>
    </el-card>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="图片路径" prop="imagePath">
          <el-input v-model="form.imagePath" placeholder="请输入图片URL"></el-input>
        </el-form-item>
        <el-form-item label="上传图片">
          <el-upload
            :http-request="handleCustomUpload"
            :before-upload="beforeUpload"
            :show-file-list="false">
            <el-button size="small" type="primary">点击上传</el-button>
            <div class="el-upload__tip">支持图片，大小不超过 10MB</div>
          </el-upload>
          <div v-if="form.imagePath" class="uploaded-media">
            <img :src="form.imagePath" class="preview-img">
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="图片预览" :visible.sync="previewVisible" width="800px">
      <div class="media-container">
        <img :src="previewUrl" class="preview-full-img">
      </div>
    </el-dialog>
  </div>
  </template>
<script>
import { homeImageApi, uploadApi } from '@/api'
export default {
  name: 'HomeImageManagement',
  data() {
    return {
      images: [],
      loading: false,
      dialogVisible: false,
      previewVisible: false,
      dialogTitle: '新增轮播图',
      previewUrl: '',
      uploading: false,
      form: {
        id: null,
        imagePath: ''
      },
      rules: {
        imagePath: [{ required: true, message: '请输入图片路径或上传图片', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadImages()
  },
  methods: {
    async loadImages() {
      this.loading = true
      try {
        const data = await homeImageApi.getAll()
        this.images = Array.isArray(data) ? data : []
      } catch (e) {
        this.$message.error('加载失败: ' + (e.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },
    handleAdd() {
      this.dialogTitle = '新增轮播图'
      this.form = { id: null, imagePath: '' }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑轮播图'
      this.form = {
        id: row.id,
        imagePath: row.imagePath || row.image_path || ''
      }
      this.dialogVisible = true
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除这个轮播图吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await homeImageApi.delete(row.id)
        this.$message.success('删除成功')
        this.loadImages()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败: ' + (error.message || '未知错误'))
        }
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        const payload = { imagePath: this.form.imagePath }
        if (this.form.id) {
          await homeImageApi.update(this.form.id, payload)
          this.$message.success('更新成功')
        } else {
          await homeImageApi.create(payload)
          this.$message.success('创建成功')
        }
        this.dialogVisible = false
        this.loadImages()
      } catch (e) {
        this.$message.error('操作失败: ' + (e.message || '未知错误'))
      }
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
        return false
      }
      return true
    },
    async handleCustomUpload(options) {
      try {
        this.uploading = true
        const response = await uploadApi.uploadFile(options.file, (progress) => {
          // 可以在这里显示上传进度
          console.log('上传进度:', progress + '%')
        })
        
        // uploadApi 返回的是经过拦截器处理后的 data.data
        // 如果后端返回 { code: 200, data: "图片URL" }，这里 response 就是 "图片URL"
        // 如果后端返回 { code: 200, data: { url: "图片URL" } }，这里 response 就是 { url: "图片URL" }
        if (typeof response === 'string') {
          this.form.imagePath = response
        } else if (response && response.url) {
          this.form.imagePath = response.url
        } else if (response && response.data) {
          this.form.imagePath = typeof response.data === 'string' ? response.data : response.data.url
        } else {
          this.form.imagePath = response
        }
        
        this.$message.success('上传成功')
      } catch (error) {
        this.$message.error('上传失败: ' + (error.message || '未知错误'))
      } finally {
        this.uploading = false
      }
    },
    previewImage(url) {
      this.previewUrl = url
      this.previewVisible = true
    }
  }
}
</script>
<style scoped>
.home-image-management {
  padding: 20px;
}
.media-preview {
  width: 60px;
  height: 60px;
  cursor: pointer;
}
.media-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.uploaded-media {
  margin-top: 10px;
}
.preview-img {
  width: 200px;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
}
.media-container {
  text-align: center;
}
.preview-full-img {
  max-width: 100%;
  max-height: 500px;
}
.empty-state {
  margin-top: 50px;
}
</style>
